import { createRegionOptionElement } from 'ui/forms';

window.lp.utils.regions = {
	/**
	 * Set countries list
	 * @param {string} selectedCountry
	 * @param {object} countries
	 * @param {HTMLElement} countriesSelectElement
	 */
	setOptionsForCountrySelect: function (selectedCountry, countries, countriesSelectElement) {

		countriesSelectElement.innerHTML = '';
		for (const property in countries) {

			const opt = document.createElement('option');
			opt.value = property;
			opt.text = countries[property];
			if (selectedCountry === property) {

				opt.setAttribute('selected', '');

			}
			countriesSelectElement.appendChild(opt);

		}

	},

	/**
	 * Appends states or provinces options to the state select element for the selected country
	 *
	 * @param {string} selectedCountry
	 * @param {string} selectedState
	 * @param {HTMLElement} stateSelectElement
	 * */

	setOptionsForStateProvinceSelect: function setOptionsForStateProvinceSelect (
		selectedCountry,
		selectedState,
		stateSelectElement
	) {

		const { regions } = window.lp.globals;
		const statesProvinces = regions[selectedCountry].States;

		stateSelectElement.innerHTML = '';

		if (!statesProvinces.length) {

			const defaultNoStateOption = createRegionOptionElement({ isSelected: true });
			// place the following when there is no states with country.
			stateSelectElement.appendChild(defaultNoStateOption);

		} else {

			selectedState = selectedState || '-1';

			const options = {
				defaultOptionLabel: 'Select a State/Province',
				defaultOptionValue: '-1',
				defaultOptionSelected: false
			};

			stateSelectElement.appendChild(
				createRegionOptionElement({
					label: options.defaultOptionLabel,
					value: options.defaultOptionValue,
					isSelected: options.defaultOptionSelected,
					isDefaultSelected: options.defaultOptionSelected
				})
			);

			for (let i = 0; i < statesProvinces.length; i++) {

				const label = statesProvinces[i].StateName;
				const value = statesProvinces[i].StateCode;
				const isSelected = value === selectedState;
				const option = createRegionOptionElement({
					value,
					label,
					isSelected,
					isDefaultSelected: isSelected
				});

				stateSelectElement.appendChild(option);

			}

		}

	}
};

(function () {

	const { regions } = lp.globals;
	const countries = {};

	for (const region in regions) {

		const countryCode = regions[region].CountryCode;
		const countryName = regions[region].CountryName;
		countries[countryCode] = countryName;

	}

	window.lp.globals.countries = countries;

}());
